import dateFormat from 'dateformat'

const initialState = {
  nippoList: null,
  nippoFiltered: null,
  nippoData: null,
  replyList: [],
  trendList: [],
  selectedTeams: [],
  selectedNippo: null,
  daysBefore: 0,
}

const nippo = (state = initialState, action) => {
  switch (action.type) {
    case 'LOAD_NIPPO_LIST':
      let nippoList = {}
      action.snapshot.docs.forEach(doc => {
        nippoList[doc.id] = doc.data()
        nippoList[doc.id].createdAt = dateFormat(doc.data().createdAt.toDate(), "yyyy/mm/dd HH:MM")
      })
      return {
        ...state,
        nippoList,
        daysBefore: 1
      }
    case 'SET_FILTERED_NIPPO':
      let nippoFiltered = {}
      let nippoFilteredMember = []
      Object.keys(action.nippoList).forEach(nippoId => {
        let data = action.nippoList[nippoId]
        let filterMatch = false
        if(action.users[data.uid] && action.users[data.uid].teams){
          filterMatch = action.users[data.uid].teams.some(teamId => {
            return action.selectedTeams.includes(teamId)? true : false
          })
        }
        if(filterMatch && !nippoFilteredMember.includes(data.uid) ){
          nippoFiltered[nippoId] = data
          nippoFilteredMember.push(data.uid)
        }
      })
      return {
        ...state,
        nippoFiltered
      }
    case 'LOAD_NEXT_NIPPO_LIST':
      let nextNippoList = state.nippoList
      action.docs.forEach(doc => {
        nextNippoList[doc.id] = doc.data()
        nextNippoList[doc.id].createdAt = dateFormat(doc.data().createdAt.toDate(), "yyyy/mm/dd HH:MM")
      })
      return {
        ...state,
        nippoList: nextNippoList,
        daysBefore: state.daysBefore + 1
      }
    case 'LOAD_NIPPO':
      let data = action.snapshot.data()
      data.createdAt = dateFormat(data.createdAt.toDate(), "yyyy/mm/dd HH:MM")
      return {
        ...state,
        nippoData: data
      }
    case 'LOAD_REPLY_LIST':
      let replyList = {}
      action.snapshot.docs.forEach(doc => {
        replyList[doc.id] = doc.data()
        replyList[doc.id].createdAt = dateFormat(doc.data().createdAt.toDate(), "yyyy/mm/dd HH:MM")
      })
      return {
        ...state,
        replyList: replyList
      }
    case 'LOAD_TREND_LIST':
      let trendList = {}
      action.docs.docs.forEach(doc => {
        trendList[doc.id] = doc.data()
        trendList[doc.id].createdAt = dateFormat(doc.data().createdAt.toDate(), "yyyy/mm/dd HH:MM")
      })
      return {
        ...state,
        trendList: trendList
      }
    case 'CHANGE_SELECTED_TEAM':
      return {
        ...state,
        selectedTeams: action.selectedTeams
      }
    case 'SELECT_NIPPO':
      return {
        ...state,
        selectedNippo: action.selectedNippo
      }
    case 'DESELECT_NIPPO':
      return {
        ...state,
        selectedNippo: null,
        nippo: null,
        replyList: []
      }
    default:
      return state
  }
}

export default nippo



// WEBPACK FOOTER //
// ./src/reducers/nippo.js